<template>
	<figure class="lazyimage" :style="'width:'+width+'px;'">
		<div class="fig-container" :style="'padding-bottom:'+scale">
			<div class="fig-canvas">
				<img src="assets/images/loading.gif" class="loader" alt="loading" width="32" height="32"/>
			</div>
		</div>
	</figure>
</template>

<script>
export default{
	name: 'Lazyimage',
	props:[
		'src',
		'width',
		'height',
		'alt'
	],
	data : function(){
		var width 	= this.width 	|| 0;
		var height 	= this.height 	|| 0;

		return {
			scale : ((height / width) * 100) +'%'
		}
	},
	methods : {
		isOnRect : function(){
			var el 		= this.$el;
			var rect 	= el.getBoundingClientRect();
			var parent 	= el.querySelector('.fig-canvas');
			var loader 	= parent.querySelector('.loader');

			if(!parent.hasLoaded){
				if(rect.top <= (window.innerHeight + 200)){
					var img 	= document.createElement('img');

					img.src 	= this.src || '';
					img.alt 	= this.alt || '';

					img.width 	= this.width 	|| 0;
					img.height 	= this.height 	|| 0;

					img.setAttribute('class','img-fluid');

					img.addEventListener('load', function(){

						parent.innerHTML = '';
						
						parent.hasLoaded = true;

						parent.appendChild(img);
						parent.classList.add('has-loaded');
					})
				}
			}
		}
	},
	mounted: function(){
		var isOnRect 	= this.isOnRect;
		var hasLazy		= false;

		isOnRect();

		window.addEventListener('scroll', function(){
			if(hasLazy) return;

			setTimeout(function(){
				hasLazy = false;
			}, 100);

			isOnRect();
		});
	}
}
</script>


// WEBPACK FOOTER //
// src/assets/vue/components/LazyImage.vue